/* eslint-disable max-classes-per-file */

import { Uppy } from '@uppy/core';
import UppyXHRUpload from '@uppy/xhr-upload';

// Adjust the default Uppy XHRUpload, so we do not send unexpected values.
// Django Rest Framework raises on unexpected fields like "relativePath" that
// are automatically added by Uppy.
export class UploadTransportPlugin extends UppyXHRUpload {
  addMetadata(formData, meta, options) {
    const { meta: globalMeta } = this.uppy.getState();

    const metaFields = Array.isArray(options.metaFields)
      ? options.metaFields
      : Object.keys(meta).filter(
          key =>
            // Ignore "relativePath" and ignore "type" unless it was explicitly
            // added to the Uppy metadata (in file metadata it is always present).
            key !== 'relativePath' && (key !== 'type' || 'type' in globalMeta),
        );

    metaFields.forEach(key => {
      formData.append(key, meta[key]);
    });
  }
}

// Adjust upload handling to be somewhat compatible with the axios responses
// we receive from our API wrapper. This allows us to use uploads with our
// `withApiRequest` higher-order component etc.
//
// - https://github.com/axios/axios#response-schema
// - https://github.com/axios/axios#handling-errors
export class UploadManager extends Uppy {
  async upload() {
    const uploadID = super.getID();
    const isContactUpload = uploadID.includes('contact');

    const { failed, successful } = await super.upload();

    if (failed.length > 0) {
      // We want an exception for contacts since the server error is needed
      // to be displayed for the end users.
      if (isContactUpload) throw new Error(failed[0].response.body);
      else throw new Error(`${failed.length} file(s) failed to upload`);
    }

    return successful;
  }
}

function resolve(path, base) {
  const url = new URL(path, base);
  return url.toString();
}

export default baseURL =>
  function makeUploader(method, url, field, restrictions) {
    const uploader = new UploadManager({
      id: [method, url].join('@'),
      restrictions,
    });

    uploader.use(UploadTransportPlugin, {
      id: [uploader.getID(), 'UploadTransportPlugin'].join(' '),
      method,
      endpoint: resolve(url, baseURL),
      headers: { Accept: 'application/json' },
      fieldName: field,
      limit: 5,
    });

    return uploader;
  };
